import React from "react";
import { BsDot } from "react-icons/bs";
import { motion } from "framer-motion";

const Experience = () => {
  return (
    <div
      name="experience"
      className="pt-24 sm:pt-20 w-full md:h-full bg-gradient-to-b  from-black to-gray-800 text-white"
    >
      <div className="max-w-screen-lg flex  flex-col  justify-center w-full h-full mx-auto p-4">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.7 }}
          variants={{
            hidden: { opacity: 0, x: -70 },
            visible: { opacity: 1, x: 0 },
          }}
          className="pb-12"
        >
          <h2 className="text-5xl ml-4 font-Dance font-bold inline border-b-4 border-gray-500">
            Experience
          </h2>
        </motion.div>

        {/* Skematix Technologies */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.7 }}
          variants={{
            hidden: { opacity: 0, y: +80 },
            visible: { opacity: 1, y: 0 },
          }}
          className="shadow-lg mb-12 important hover:scale-105 duration-200 py-5 px-4 rounded-lg shadow-gray-100"
        >
          <div className="flex text-black  justify-between">
            <h2 className="text-2xl font-bold text-gray-400 pl-4">
              Skematix Technologies
            </h2>
            <p className="font-semibold pr-6 text-gray-300">
              Sep 2022 - Present
            </p>
          </div>

          <h4 className="ml-4 mt-2">
            <span className="mr-1 font-bold">Role:</span> Web Developer
            Intern
          </h4>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Responsible for building custom web applications using Next.js,
              Eleventy, Nunjucks, Tailwindcss and NetlifyCMS.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Learnt to use AWS EC2, lambda function, Simple Email Service(SES).
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Exposure with Shopify, Hydrogen, Oxygen and worked with PostgreSQL
              and Postgraphile.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Implemented Agile development process for Software Development
              Life Cycle.
            </div>
          </div>
        </motion.div>

        {/* Team webilicious */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.7 }}
          variants={{
            hidden: { opacity: 0, y: +80 },
            visible: { opacity: 1, y: 0 },
          }}
          className="shadow-lg mb-12 important hover:scale-105 duration-200 py-5 px-4 rounded-lg shadow-gray-100"
        >
          <div className="flex text-black  justify-between">
            <h2 className="text-2xl font-bold text-gray-400 pl-4">
              Team webilicious
            </h2>
            <p className="font-semibold pr-6 text-gray-300">
              jan 2023 
            </p>
          </div>

          <h4 className="ml-4 mt-2">
            <span className="mr-1 font-bold">Role:</span> Full Stack Developer
            Intern
          </h4>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Led the development of Rurket, a rural side groceries delivery
              application, utilizing ReactJS, TailwindCSS, and Firebase for the
              backend.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Developed a strong understanding of React and implemented Agile
              methodology throughout the software development lifecycle.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Responsible for end-to-end testing and reviewing of code to ensure
              high-quality and functionality.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Built the application to be a Progressive Web Application to
              provide a seamless user experience.
            </div>
          </div>
        </motion.div>

        {/* Neophron Technologies */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, y: +90 },
            visible: { opacity: 1, y: 0 },
          }}
          className="shadow-lg hover:scale-105 duration-200 py-5 px-4 rounded-lg shadow-gray-100"
        >
          <div className="flex text-black  justify-between">
            <h2 className="text-2xl font-bold text-gray-400 pl-4">
              Neophron Technologies
            </h2>
            <p className="font-semibold pr-6 text-gray-300">July 2022</p>
          </div>

          <h4 className="ml-4 mt-2">
            <span className="mr-1 font-bold">Role:</span> Backend Developer
            Intern
          </h4>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Responsible for backend development with popular technologies like
              Node.js, Express.js and MongoDB.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Built API with REST Architecture for a project and got exposure
              with Postman.
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Got exposure to devops tools that increases an organization's
              ability to deliver applications and services.
            </div>
          </div>
          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Handled project phases from planning stage to deployment and
              maintenance stage
            </div>
          </div>

          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Learnt about distributed version control system like git and
              hosting service like Github
            </div>
          </div>
          <div className="flex flex-row text-md mt-2">
            <BsDot size={40} color="darkGray" />
            <div className="ml-2 mt-2 text-gray-300">
              Implemented Agile development process for Software Development
              Life Cycle.
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Experience;
